import ReactDOM from 'react-dom'
import '@/assets/scss/main.scss'
import '@/i18n'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
